module.exports = __webpack_public_path__ + "static/img/2.b608288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R507/2.jpg
// module id = r4JZ
// module chunks = 1